import * as THREE from 'three'

let TWEEN = require('@tweenjs/tween.js')
let OrbitControls = require('three-orbit-controls')(THREE)

class LoadModel {
    init(url) {
        this.url = url
        let container = document.createElement('div')
        container.setAttribute('id', 'container')
        document.body.appendChild(container)
        this.renderer = new THREE.WebGLRenderer({antialias: true, alpha: true})
        this.renderer.setClearColor(0xFFFFFF, 0.0)
        // eslint-disable-next-line
        this.renderer.setPixelRatio(window.devicePixelRatio)
        this.renderer.setSize(window.innerWidth, window.innerHeight)
        // eslint-disable-next-line
        container.appendChild(this.renderer.domElement)
        this.loading(url)
        let that = this
        window.addEventListener('resize', function () {
            that.onWindowResize()
        }, false)
        this.sceneupdate = function () {
            return false
        }
    }

    ChangeControls(position) {
        this.controls = new OrbitControls(this.camera, this.renderer.domElement)
        this.camera.lookAt(position)
        this.controls.target.x = position.x
        this.controls.target.y = position.y
        this.controls.target.z = position.z
        this.controls.dampingFactor = 0.25
        this.controls.enableZoom = false
        // this.controls.zoomSpeed = 0.8
        // this.controls.rotateSpeed = 0.4
    }

    EndControls() {
        this.controls.enabled = false
    }

    render() {
        if (this.camera) {
            this.renderer.render(this.scene, this.camera)
        }
        // if (this.controls) {
        // this.controls.update()
        // }
        // eslint-disable-next-line
        this.SceneUpdate()
        TWEEN.update()
    }

    tween(movement) {
        // eslint-disable-next-line
        return new TWEEN.Tween(movement)
    }

    tweenClear() {
        TWEEN.removeAll()
    }

    animate() {
        this.animateId = window.requestAnimationFrame(this.animate.bind(this))
        this.render()
    }

    onWindowResize() {
        this.renderer.setSize(window.innerWidth, window.innerHeight)
        if (this.camera) {
            this.camera.aspect = window.innerWidth / window.innerHeight
            this.camera.updateProjectionMatrix()
        }
    }

    loading(url) {
        let that = this
        let loader = new THREE.ObjectLoader()
        loader.load(this.url.url, function (obj) {
            that.append(obj)
        })
    }

    append(obj) {
        this.scene = obj
        // const cc = obj
        // this.models = cc
        this.scene.traverse(function (e) {
            e.visible = false
        })
        this.camera = new THREE.PerspectiveCamera(84, window.innerWidth / window.innerHeight, 0.005, 20000)
        this.stats = 's0_1'
    }

    SceneUpdate() {
        if (this.sceneupdate()) {
            this.sceneupdate()
        }
    }
}

export default LoadModel



// WEBPACK FOOTER //
// ./src/js/views/3DModels.js